import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import ContentAlert from "./ContentAlert";

const ContentMath = ({ latex, display, showIcon }) => {
	const classes = useStyles("Content");

	const katex = require("katex"); // https://katex.org/docs/node.html https://katex.org/docs/options.html for rendering math equations
	var html = katex.renderToString(latex, {
		//displayMode: display, // inline = false, block = true
		throwOnError: false,
	});

	return (
		<>
			{display ? (
				<ContentAlert
					severity={"info"}
					iconAlias={showIcon ? "formula" : "none"}
					CustomMessage={
						<span
							class="katex block"
							dangerouslySetInnerHTML={{ __html: html }}
						/>
					}
				/>
			) : (
				<span
					className="katex inline"
					dangerouslySetInnerHTML={{ __html: html }}
				/>
			)}
		</>
	);
};

ContentMath.defaultProps = {
	display: true,
	showIcon: false,
};

ContentMath.propTypes = {};
export default ContentMath;
